<template lang="pug">
  .field(:class="{'input-text-has-error': !valid}")
    label.label(v-if="label")
      span(v-if="asterisk")
      | {{ label }}

    .control
      input.input(
        :type="type",
        v-bind="$attrs",
        v-model="state",
        ref="input",
        v-on="listeners")

    p(v-if="!valid") {{ invalidMessage ? invalidMessage : 'Campo necessário' }}

</template>

<script>
import { handlerUseStateVmodel } from '../mixins'

export default {
  computed: {
    listeners () {
      const listeners = {...this.$listeners}
      delete listeners['input']
      return listeners
    }
  },
  mixins: [handlerUseStateVmodel(), {
    methods: {
      focus () {
        if (this.$refs['input']) {
          this.$refs['input'].focus()
        }
      }
    }
  }],
  inheritAttrs: false,
  name: 'input-generic',
  props: {
    type: {'default': 'text', type: String},
    label: { type: String, default: '' },
    asterisk: { type: Boolean, default: false },
    className: { type: String, default: '' },
    disabled: { default: false },
    valid: {type: Boolean, 'default': true},
    invalidMessage: {type: String, 'default': ''},
  }
}
</script>

<style scoped>
.inline-input {
  display: inline;
  padding: 0 3px;
  margin: 0 3px;
  width: 40px;
  height: 25px;
  border-radius: 1px;
}
.input-text-has-error {
  color: red;
}

input {
  width: 100%;
  border-radius: 0px;
  background: #fff;
  border: 1px solid #ccc;
  outline:none;
  padding: 6px;
  height: 50px;
}

input:focus{
  border:1px solid #56b4ef;
  box-shadow: 0px 0px 3px 1px #c8def0;
}
</style>
